import React, { useState ,useMemo} from "react";
import SplineModel from "../shared/SplineModel";
import { motion, AnimatePresence } from "framer-motion";
import "./About_section.css";

export function AboutSection({ isVisible }) {
    const [activeSection, setActiveSection] = useState(null);
    const [modelLoaded, setModelLoaded] = useState(false);
    const isMobile = useMemo(() => window.innerWidth <= 768, []);


    const contentSections = [
        {
            id: 'intro',
            icon: '🎯',
            position: { top: '15%', left: '15%' },
            mobilePosition: { top: '10%', left: '10%' },
            title: 'About Me',
            content: `Hey there! I'm Suresh Paliwal, a Full Stack Developer & AI/ML Enthusiast with a passion for creating innovative solutions.`
        },
        {
            id: 'journey',
            icon: '🚀',
            position: { top: '15%', right: '15%' },
            mobilePosition: { top: '10%', right: '10%' },
            title: 'My Journey',
            content: `From diving deep into DSA with C++ & Python to exploring the vast world of machine learning and deep learning, my tech journey has been driven by curiosity and innovation.`
        },
        {
            id: 'skills',
            icon: '⚡',
            position: { top: '50%', left: '10%' },
            mobilePosition: { top: '40%', left: '20%' },
            title: 'Beyond Web Development',
            content: `Exploring the realms of cybersecurity with tools like BetterCap and Arpspoof, while expanding into hardware interfacing and embedded systems.`
        },
        {
            id: 'current',
            icon: '💡',
            position: { top: '50%', right: '10%' },
            mobilePosition: { top: '40%', right: '20%' },
            title: "Current Focus",
            content: `• Running Skill Nest - Knowledge Sharing Platform\n• Experimenting with Cutting-edge Tech\n• Building AI-integrated Solutions`
        },
        {
            id: 'hobbies',
            icon: '🎮',
            position: { top: '75%', left: '50%', transform: 'translateX(-50%)' },
            mobilePosition: { top: '70%', left: '50%', transform: 'translateX(-50%)' },
            title: "Beyond Coding",
            content: `When not coding, you'll find me:\n• Binge-watching anime\n• Exploring new tech trends\n• Brainstorming innovative projects`
        }
    ];

    const getPosition = useMemo(() => (section) => {
        return isMobile ? section.mobilePosition : section.position;
    }, [isMobile]);

    if (!isVisible) return null;

    return (
        <div className="about-section">
            {!isMobile && (
                <div className="model-container">
                    <SplineModel onLoaded={() => setModelLoaded(true)} />
                </div>
            )}

            {/* Mobile view */}
            {isMobile ? (
                <div className="mobile-about-content">
                    {contentSections.map((section) => (
                        <div key={section.id} className="mobile-section">
                            <div className="mobile-section-header">
                                <span className="mobile-icon">{section.icon}</span>
                                <h3>{section.title}</h3>
                            </div>
                            <p>{section.content}</p>
                        </div>
                    ))}
                </div>
            ) : (
                /* Desktop view - existing interactive content */
                modelLoaded && (
                    <>
                        {contentSections.map((section) => (
                            <div
                                key={section.id}
                                className="floating-icon"
                                style={{
                                    ...getPosition(section),
                                    position: 'absolute'
                                }}
                                onMouseEnter={() => setActiveSection(section.id)}
                                onMouseLeave={() => setActiveSection(null)}
                            >
                                <motion.div className="icon-container">
                                    {section.icon}
                                </motion.div>
                            </div>
                        ))}

                        <AnimatePresence>
                            {activeSection && (
                                <motion.div
                                    className="content-card"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.9 }}
                                    transition={{
                                        duration: 0.2,
                                        ease: "easeOut"
                                    }}
                                >
                                    <h3>{contentSections.find(s => s.id === activeSection)?.title}</h3>
                                    <p>{contentSections.find(s => s.id === activeSection)?.content}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </>
                )
            )}
        </div>
    );
}

export default AboutSection;
